import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of, switchMap, tap } from 'rxjs';
import { HelperService } from 'src/app/service/helper.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { Region } from '../../../model/region.model';

@Injectable({
    providedIn: 'root'
})
export class RegionDataService extends DefaultDataService<Region> {
    r: Region[] = [];
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService, public helperService: HelperService) {
        super('Region', http, httpUrlGenerator);
    }

    override getAll(): Observable<Region[]> {
        const url = this.urlProvider.getUrl(EndPoints.region, undefined, undefined);
        return this.http
            .get(
                url,
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    this.r = <Region[]>res.body['regions'];
                    this.r = this.r.filter((item) => item.CODE != '12');
                    this.r = this.r.filter((item) => item.CODE != '13');
                    this.r = this.r.filter((item) => item.CODE != '15');
                    this.r = this.r.filter((item) => item.CODE != '20');

                    this.helperService.setRegionListObject(this.r);
                    return of(this.r);
                })
            );
    }
}
